export default class SendboxItem2 {
  /**
   * The User notification object used to display in snackbar for instance
   * @typedef {Object} UserNotification
   * @property {boolean} show - true indicates the user should be notified by this action, e.g. by displaying in snackbar or the like
   * @property {boolean} showInSendbox - true to make the item visible within the sendbox display
   * @property {string} title - display title snackbar and sendbox
   * @property {string} text - Display text in user notification (e.g. snackbar, but not in sendbox)
   *   
  /**
   * Required sub-object properties of each subject
   * - _userState
   * - _displayLocation
   * - _moduleId
   * - _moduleTitle
   * - _modulePath
  /**
   * Constructs a SendboxItem for processing by sendboxStore.
   * @param {string} moduleType - The moduleType defined in index.js of each module. Must match the cockpit module config type. This will be used to store to module db user state
   * @param {string} moduleId - The moduleType defined in index.js of each module. This is the moduleId used as vuex store id
   * @param {string} writeAuditLog - If true, the action is being inserted into the device log table
   * @param {UserNotification} userNotification - The UserNotification object containing all information required to display
   * @param {Subject} subject - the subject, e.g. a document meta data item
   * @param {UserState} userState - The module specific userState to store
   * @param {Object} payload - payload - arbitrary payload to send with
   * @param {string} action - action identifier used to perform the action server side
   */
  constructor({ moduleType, moduleId, writeAuditLog, userNotification, subject, userState, payload, action }) {
    this.moduleType = moduleType;
    this.moduleId = moduleId;
    this.writeAuditLog = writeAuditLog;
    this.userNotification = userNotification;
    this.subject = subject;
    this.userState = userState;
    this.payload = payload;
    this.action = action;
  }
}
